module.exports = __webpack_public_path__ + "img/NAMA.ac30d9fc.svg";